import { render, staticRenderFns } from "./ProviderRequestsView.vue?vue&type=template&id=5ce0d2a6"
import script from "./ProviderRequestsView.vue?vue&type=script&lang=js"
export * from "./ProviderRequestsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports